<template>
    <div>
        
        <div class="row">
            <div class="col-6">
                <div class="text-left section-title" style="padding: 5px;">
                  <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                        <template v-if="buildingId">
                            <span row-table-font-margins style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center;'> {{ buildingName}} / </span>
                        </template>
                        Statement
                    </span>
                    <p style="
            font-size: 15px;
            font-family: inherit;
            font-weight: 500;
            
            text-transform: uppercase;
          ">
                        {{ contact.name }} / {{ propertyName }}
                    </p>
                    <!-- <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                        
                            Statement for
                            <span v-if="propertyName !== 'Uncollected income' & propertyName !== 'Creditors'">Unit </span>
                            {{ propertyName }}
                            <span v-if="propertyName !== 'Rest of properties' & propertyName !== 'Uncollected income' & propertyName !== 'Creditors'">, owner: {{contact.name}}</span>
                        
                      
                    </span> -->
                </div>
            </div>
            <div class="col-6 add-button-section">
                <div class="text-right" style="padding: 5px;">
                    <!--<span style="margin-right:5px">Add New Unit</span>
            <router-link class="btn btn-table" :to="{
      name: 'property',
      params: { buildingId: buildingId, buildingName: buildingName },
    }"><i class="fas fa-plus"></i></router-link>-->
                    <span style=" width: 30px; height: 30px; border-radius: 5px; background-color: #007DFC; color: white; display: inline-block; padding-left: 5px; padding-right: 5px; text-align: center; cursor: pointer; ">
                        <i class="fa fa-sliders-h" style="margin-top:7px;transform: rotate(-90deg);" aria-hidden="true"></i>
                    </span>
                    <period-select style="margin-left:-1px!important;border-left:0px;margin-right:8px;" class="select" id="period" name="period" :building-id="buildingId" v-model="period" />

                    <router-link data-toggle="tooltip" data-placement="top" title="Invoices" class="btn btn-table" :to="{
                    name: 'invoices',
                    params: {
                      propertyId: propertyId,
                      buildingId: buildingId,
                      buildingName: buildingName,
                      propertyName: propertyName,
                    },
                  }"
                                 style="
                              width: 30px;
                              height: 30px;
                              border-radius: 5px;
                              background-color: #212121;
                              color: white!important;
                              display: inline-block;
                              padding-left: 5px;
                              padding-right: 5px;
                              text-align: center;
                              cursor:pointer;
                              margin-right: 8px;
                              ">
                        <i class="fas fa-file-invoice" style="margin-top:7px;" aria-hidden="true"></i>
                    </router-link>
                    <span @click="exportToPDF()"
                          style="
width: 30px;
height: 30px;
border-radius: 5px;
background-color: #007DFC;
color: white;
display: inline-block;
padding-left: 5px;
padding-right: 5px;
text-align: center;
cursor:pointer;

">
                        <i class="fa fa-file-export" style="margin-top:7px;" aria-hidden="true"></i>
                    </span>
                    <a @click="$router.go(-1)" class="btn btn-cancel" style="padding: inherit; height: 30px; line-height: 17px;margin-left:5px;">Back</a>
                    <userMenu />
                </div>
            </div>

        </div>
        
        <div id="property-admin">
            <div>
                <propertystatement :key="period" :unit-id=propertyId :building-id=buildingId :building-name=buildingName :period="period" :owner="false"></propertystatement>
            </div>



            <property-expenses style="margin-top:25px;" :key="period" :unit-id=propertyId :period="period" :owner="false"></property-expenses>

            <property-expense style="margin-top:15px;" :key="period" :unit-id=propertyId :building-id=buildingId :period="period" :owner="false"></property-expense>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import html2pdf from "html2pdf.js"
export default {
  data: function () {
    return {
      committees: [],
   //   buildingId: 0,
  //    buildingName: "",
   //   propertyName: "",
      expenseTypeId: 0,
      expenseTypes: [],
      period: 1,
      contact: [],
    };
  },
  watch: {
    value(val) {
      this.$emit("update:propertyId", val);
    },
    propertyId(val) {
      this.value = val;
      this.fetchStatement();
    },
  },
  mounted() {
    this.ensureBuilding();
  //  this.buildingId = this.$route.params.buildingId;
 //   this.buildingName = this.$route.params.buildingName;
  //  this.propertyName = this.$route.params.propertyName;
  //  this.propertyId = this.$route.params.propertyId;
    //this.buildingName = this.$route.params.buildingName;
    if(this.$route.params.propertyName != null && this.$route.params.propertyName.length > 0)
      this.$store.commit('property/SET_CURRENT_PROPERTY_NAME', this.$route.params.propertyName)
    if(this.$route.params.propertyId != null && this.$route.params.propertyId > 0)
      this.$store.commit('property/SET_CURRENT_PROPERTY_ID', this.$route.params.propertyId)
      if(this.$route.params.period != null)
        this.period = this.$route.params.period
    this.fetchStatement();
    this.getProperty();
  },
  computed:{
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      propertyName:(state) => state.property.currentPropertyName,
      propertyId:(state) => state.property.currentPropertyId,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    buildingId(){
      if(this.$route.params.buildingId)
        return this.$route.params.buildingId;
      if(this.building != null)
        return  this.building.id;
      return ""
    },
  },
  methods: {
    ensureBuilding() {
      const id = Number(this.$route.params.buildingId);
      if (id > 0 && Number(this.building && this.building.id) !== id) {
        this.$store.dispatch("building/fetchBuilding", id);
      }
    },
    forceUpdate() {
      this.$forceUpdate();
    },
            exportToPDF() {
    html2pdf(document.getElementById("property-admin"), {
        margin: 1,
        filename: "property-statement.pdf",
        html2canvas: { scale: 2 },
        enableLinks: false,
        jsPDF: { orientation: 'landscape' }
    });
},
    fetchStatement: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/expenseTypes/building?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.expenseTypes = data;
        });
    },

    changed: function () {
      this.fetchStatement();
    },
    getProperty: function () {
      this.$http.get("/properties/" + this.propertyId).then((response) => {
        this.contact = response.data.contact;
      });
    },
    deleteItem: function destroy(item) {
      var r = confirm("Are you sure you want to delete committee member?");
      if (r == true) {
        var _this = this;
        this.axios.delete("/committees/" + item.id).then(function () {
          _this.fetchStatement();
          // _this.getVueItems();
          //_this.hasDeleted = false
        });
      }
    },
  },
};
</script>